<template lang="pug">
  button.tt(:style="sty()",@mousedown="mousedown",@touchstart="mousedown")
    img(src="@/assets/ico_tgl_tb.svg")
    <!--div.bln {{ cm }}cm-->
</template>

<script>
export default {
  name: 'SizeHeight',
  components: {
  },
  data () {
    return {
      cm: 0,
      val: 0,
      prevval: 0,
      kht: 0,
      flg: false,
      set: {},
      bottom: 0
    };
  },
  props: {
    ht: Number
  },
  computed: {
  },
  watch: {
    number () {
      this.set = this.sets[this.number];
      if (this.set !== undefined) {
        this.bottom = this.c2p(this.set.size[1]);
        this.kht = this.c2p(this.set.size[1]);
      }
    },
    sets () {
      if (this.set !== undefined) {
        this.bottom = this.c2p(this.set.size[1]);
      }
    }
  },
  methods: {
    mousedown (e) {
      this.startY = this.mp(e).clientY;
      this.flg = true;
      window.addEventListener('mousemove', this.mousemove, false);
      window.addEventListener('mouseup', this.mouseup, false);
      window.addEventListener('touchmove', this.mousemove, false);
      window.addEventListener('touchend', this.mouseup, false);
    },
    mousemove (e) {
      if (this.flg) {
        this.height = this.startY - this.mp(e).clientY + this.kht;
        let diff = [];
        let index = 0;
        for (let prop in this.slititems) {
          diff[prop] = Math.abs((this.p2c(this.height)) - this.slititems[prop].pos);
          index = (diff[index] < diff[prop]) ? index : prop;
        }
        let val = this.c2p(this.slititems[index].pos);
        if (this.prevval !== val) {
          this.$emit('change', this.p2c(val));
        }
        this.prevval = val;
      }
    },
    mouseup () {
      this.flg = false;
      this.kht = this.c2p(this.set.size[1]);
      window.removeEventListener('mousemove', this.mousemove);
      window.removeEventListener('mouseup', this.mouseup);
      window.removeEventListener('touchmove', this.mousemove);
      window.removeEventListener('touchend', this.mouseup);
    },
    sty () {
      return {
        bottom: this.bottom + 'px'
      };
    }
  },
  created () {
    this.height = this.ht;
    this.set = this.sets[this.number];
    if (this.set !== undefined) {
      this.bottom = this.c2p(this.set.size[1]);
      this.kht = this.c2p(this.set.size[1]);
    }
  }
};
</script>

<style lang="stylus" scoped>
  .tt
    position absolute
    left 50%
    bottom 470px
    z-index 1
    transform translate(-50%,-100%)
    .preview &
      display none
    .bln
      position absolute
      left 50%
      top -60%
      transform translate(-50%,0)
    img
      pointer-events none
</style>



// WEBPACK FOOTER //
// src/components/front/SizeHeight.vue